import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedServiceService {
  constructor() {

  }
  inputs = [];
  // =================== BEGIN SYSTEM NOTIFICATION =======================
  public notification: BehaviorSubject<any> = new BehaviorSubject(false);
  // =================== BEGIN Orientation Lock =======================
  onorientationchange: BehaviorSubject<boolean> = new BehaviorSubject(false);
  pushNotification(messageObj: any): void {
    this.notification.next(messageObj);
  }
  setOnorientationchange(isOriented = false) {
    this.onorientationchange.next(isOriented);
  }
  handleInputFocus() {
    const inputs = document.getElementsByTagName('input');
    const inputLenght = inputs.length;
    for (let i = 0; i < inputLenght; i++) {
      inputs[i].addEventListener('focusin', this.handleBodyOpen );
      inputs[i].addEventListener('focusout', this.handleBodyClose );
    }
    const selectors = document.getElementsByTagName('select');
    const selectorLenght = selectors.length;
    for (let j = 0; j < selectorLenght; j++) {
      selectors[j].addEventListener('focusin', this.handleBodyOpen );
      selectors[j].addEventListener('focusout', this.handleBodyClose );
    }
    const textareas = document.getElementsByTagName('textarea');
    const texrareaLenght = textareas.length;
    for (let k = 0; k < texrareaLenght; k++) {
      textareas[k].addEventListener('focusin', this.handleBodyOpen );
      textareas[k].addEventListener('focusout', this.handleBodyClose );
    }
  }
  handleBodyOpen() {
    document.getElementsByTagName('body')[0].classList.add('panel_open');
    document.getElementsByTagName('html')[0].classList.add('panel_open');
  }
  handleBodyClose() {
    document.getElementsByTagName('body')[0].classList.remove('panel_open');
    document.getElementsByTagName('html')[0].classList.remove('panel_open');
  }
  convertToEnglishNumber(value) {
    const temp = [];
    let result = '';
    for (let i = 0; i < value.length; i++) {
      if (value.charCodeAt(i) > 1000) {
        const x = value.charCodeAt(i) - 1728;
        temp[i] = String.fromCharCode(x);
      } else {
        temp[i] = value[i];
      }
    }
    if (temp.length === value.length) {
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < temp.length; i++) {
        result += temp[i];
      }
    } else {
      result = value;
    }
    return result;
  }
  detectFarsiNumber(value) {
    const temp = [];
    let result = '';
    for (let i = 0; i < value.length; i++) {
      if (value.charCodeAt(i) >= 1776 && value.charCodeAt(i) <= 1785) {
        const x = value.charCodeAt(i) - 1728;
        temp[i] = String.fromCharCode(x);
      } else {
        temp[i] = value[i];
      }
    }
    if (temp.length === value.length) {
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < temp.length; i++) {
        result += temp[i];
      }
    } else {
      result = value;
    }
    return result;
  }
  convertTofarsiNumber(value) {
    const temp = [];
    let result = '';
    for (let i = 0; i < value.length; i++) {
      if (value[i] === ',' || value[i] === '/' || value[i] === '-') {
        temp[i] = value[i];
      } else if (value.charCodeAt(i) < 1000) {
        const x = value.charCodeAt(i) + 1728;
        temp[i] = String.fromCharCode(x);
      } else {
        temp[i] = value[i];
      }
    }
    if (temp.length === value.length) {
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < temp.length; i++) {
        result += temp[i];
      }
    } else {
      result = value;
    }
    return result;
  }
  numberValidate(evt) {
    // tslint:disable-next-line: deprecation
    evt = (evt) ? evt : window.event;
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
      evt.preventDefault();
    } else {
      return true;
    }
  }
  numberInput(evt) {
    evt = (evt) ? evt : window.event;
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 65 && charCode < 122) {
      evt.preventDefault();
    } else {
      return true;
    }
  }
  farsiNumberValidate(evt) {
    // tslint:disable-next-line: deprecation
    evt = (evt) ? evt : window.event;
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
      evt.preventDefault();
    } else {
      return charCode + 1726;
    }
  }
  convertToEnglishNumber1(value) {
       const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
       const arabicNumbers  = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
       if (typeof value === 'string') {
      for (let i = 0; i < 10; i++) {
        value = value.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
       return value;
  }
  checkMonthValue(value) {
    if (value.length === 1) {
      return false;
    }
    const temp = Number(value);
    if (temp < 0 || temp > 12) {
      return false;
    }
    return true;
  }
  checkYearValue(value) {
    if (value.length === 1) {
      return false;
    }
    const temp = Number(value);
    if (temp > 9 && temp !== 99) {
      return false;
    }
    return true;
  }
  mainareaHeight() {
    // mainarea pages
    const mainArea = document.getElementsByClassName('mainarea')[0] as HTMLElement;
    if (mainArea) {
      mainArea.style.height = (window.innerHeight  - 49 ) + 'px';
    }
    const mainAreaFull = document.getElementsByClassName('mainarea_full');
    if (mainAreaFull) {
      const mainAreaFullLenght = mainAreaFull.length;
      for (let i = 0 ; i < mainAreaFullLenght; i++) {
        const x = mainAreaFull[i] as HTMLElement;
        x.style.height = window.innerHeight + 'px';
      }
    }
    // mainarea receipt-page
    const receiptBack = document.getElementsByClassName('receipt-back')[0] as HTMLElement;
    const receiptBody = document.getElementsByClassName('receipt-body');
    if (receiptBody) {
      const receiptBodyLenght = receiptBody.length;
      for (let i = 0 ; i < receiptBodyLenght; i++) {
        const x = receiptBody[i] as HTMLElement;
        x.style.maxHeight = (window.innerHeight - receiptBack.offsetHeight - 20) + 'px';
        // x.style.maxHeight = (window.innerHeight - receiptBack.offsetHeight - 70) + 'px';

      }
    }
    // mainarea tab-content
    const mainareaTabContent =
    document.getElementsByClassName('mainarea_tab_content')[0] as HTMLElement;
    if (mainareaTabContent) {
      mainareaTabContent.style.maxHeight = (window.innerHeight - 100) + 'px';
    }
  }
  handlePopupBottom() {
    const popups = document.getElementsByClassName('upSlider');
    const popupsLenght = popups.length;
    if (popups) {
      for (let i = 0 ; i < popupsLenght; i++) {
        const x = popups[i] as HTMLElement;
        if (x.classList.contains('show')) {
          x.style.bottom = document.getElementsByTagName('body')[0].offsetHeight - window.innerHeight + 'px';
        } else {
          x.style.bottom = -1000 + 'px';
        }
      }
    }
  }
  isValidPan(pan) {
    let sum = 0;
    let mul = 0;
    for (let i = 0; i < pan.length; i++) {
      if (i % 2 === 0) {
        mul = pan[i] * 2;
        if (mul >= 10) {
          mul = mul - 9;
        }
        sum += mul;
      }

      if (i % 2 !== 0) {
        mul = pan[i] * 1;
        if (mul >= 10) {
          mul = mul - 9;
        }
        sum += mul;
      }
    }
    return (sum % 10 !== 0);
  }
  nationalCodeValidation(code) {
    code = this.convertToEnglishNumber(code);
    if (!/^\d{10}$/.test(code)) {
      return false;
    }
    if (code.length !== 10) {
      return false;
    }
    const check = Number(code[9]);
    let sum = 0;
    for (let i = 0; i < 9; ++i) {
      sum += Number(code[i]) * (10 - i);
    }
    sum %= 11;
    if ((sum < 2 && check === sum) || (sum >= 2 && check + sum === 11)) {
      return true;
    }
    return false;
  }
  calcuteAmount(records: []) {
    records.forEach((transaction: any) => {
      if (transaction.pinChargePurchaseDetails) {
        transaction.type = 'pinCharge';
        transaction.amount = transaction.pinChargePurchaseDetails.amount;
      } else if (transaction.topUpPurchaseDetails) {
        transaction.type = 'imCharge';
        transaction.amount = transaction.topUpPurchaseDetails.amount;
      } else if (transaction.billPaymentDetails && transaction.resourceType !== 'Deposit') {
        transaction.type = 'card-bill';
        transaction.amount = transaction.billPaymentDetails.amount;
      } else if (transaction.fundTransferDetails && transaction.fundTransferDetails.destResourceType === 'Card') {
        transaction.type = 'transfer';
        transaction.amount = transaction.fundTransferDetails.amount;
      } else if (transaction.merchantPayByIdDetails) {
        transaction.type = 'merchant';
        transaction.amount = transaction.merchantPayByIdDetails.amount;
      } else if (transaction.packagePurchaseDetails) {
        transaction.type = 'package';
        transaction.amount = transaction.packagePurchaseDetails.amount;
      } else if (transaction.charityPaymentDetails) {
        transaction.type = 'charity';
        transaction.amount = transaction.charityPaymentDetails.amount;
      } else if (transaction.loanPaymentDetails) {
        transaction.type = 'payloandeposit';
        transaction.amount = transaction.loanPaymentDetails.amount;
      } else if (transaction.fundTransferDetails && transaction.fundTransferDetails.destResourceType === 'Deposit') {
        transaction.type = 'deposittransfer';
        transaction.amount = transaction.fundTransferDetails.amount;
      } else if (transaction.fundTransferDetails && transaction.fundTransferDetails.destResourceType === 'IBAN') {
        transaction.type = 'ibantransfer';
        transaction.amount = transaction.fundTransferDetails.amount;
      } else if (transaction.billPaymentDetails && transaction.resourceType === 'Deposit') {
        transaction.type = 'deposit-bill';
        transaction.amount = transaction.billPaymentDetails.amount;
      } else if (transaction.fundPaymentDetails) {
        transaction.type = 'issueFund';
        transaction.amount = transaction.fundPaymentDetails.amount;
      } else if (transaction.insurancePaymentDetails) {
        transaction.type = 'insurance';
        transaction.amount = transaction.insurancePaymentDetails.amount;
      } else if (transaction.etfDetails) {
        transaction.type = 'etf';
        transaction.amount = transaction.etfDetails.amount;
      }
    });
  }
}
